const PANEL_CONFIG = {
    WIDTH: 160,
    WIDE_WIDTH: 360,
    HEIGHT: 96,
    TEXT_PADDING: 3,
    TEXT_Y_OFFSET: 2,
    GRAPH_Y_OFFSET: 15,
    GRAPH_WIDTH: 150,
    GRAPH_HEIGHT: 70,
    FONT_SIZE: 9,
    FONT_FAMILY: 'Helvetica,Arial,sans-serif',
    GRAPH_ALPHA: 0.9,
};
const STATS_CONFIG = {
    UPDATE_INTERVAL: 1000,
    MAX_MS_VALUE: 200,
    MAX_FPS_VALUE: 300,
    OVERLAY_STYLES: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        left: 'auto',
        zIndex: '9999',
        cursor: 'move',
        opacity: '0.9',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: '4px',
        maxWidth: 'calc(100vw - 8px)',
        userSelect: 'none',
    },
    POSITION_STORAGE_KEY: 'cornerstone-stats-overlay-position',
};
const CONVERSION = {
    BYTES_TO_MB: 1048576,
    MS_PER_SECOND: 1000,
};
const PANEL_CONFIGS = [
    { name: 'FPS', foregroundColor: '#0ff', backgroundColor: '#002' },
    { name: 'MS', foregroundColor: '#0f0', backgroundColor: '#020' },
    { name: 'MB', foregroundColor: '#f08', backgroundColor: '#201' },
    {
        name: 'VIEWPORT BINDINGS',
        foregroundColor: '#fc0',
        backgroundColor: '#221100',
    },
];
export { PANEL_CONFIG, STATS_CONFIG, CONVERSION, PANEL_CONFIGS };
